import ApiService from './api_services'

const OverheidApi = {
  bag: function (searchParams) {
    return ApiService.get('/overheid/bag', { params: searchParams })
  }
}

export default OverheidApi
